import React from "react";
import { useHistory } from "react-router";
import { Input, InputGroup } from "rsuite";
import { AppRouteApi, AppRouteUi } from "../../../config/appRoute";
import axios from "axios";
import { ApiResponseContainer } from "../../../models/api";
import { Link } from "react-router-dom";
import { AuthLayout } from "../../components/authLayout";
import { Button } from "../../../components/button.component";

export function PageAuthForgotPassword(): JSX.Element {
  const [msg, setMsg] = React.useState<string>();
  const [isBusy, setIsBusy] = React.useState<boolean>(false);
  const [userEmail, setUserEmail] = React.useState<string>();
  const { push: historyPush } = useHistory();
  const onPasswordReset = React.useCallback(
    async (userEmail: string) => {
      setIsBusy(true);
      try {
        const response = await axios.get<ApiResponseContainer<{}>>(
          AppRouteApi.Auth.ForgotPassword(userEmail)
        );
        if (response.data.isSuccess)
          historyPush(AppRouteUi.Login.ResetPassword());
        else setMsg(response.data.message);
      } catch (e) {
        setMsg(String(e));
      }
      setIsBusy(false);
    },
    [historyPush]
  );

  return (
    <AuthLayout>
      <div className="px-3">
        <h4 className="text-center fw-light my-3">Forgot Password</h4>
        {!msg ? (
          <div>
            <InputGroup className="mb-2">
              <Input
                placeholder="Email"
                type="email"
                onChange={(email) => setUserEmail(`${email}`)}
              />
            </InputGroup>
            <div className="d-flex justify-content-center">
              <Button
                onClick={() => userEmail && onPasswordReset(userEmail)}
                disabled={!userEmail}
                loading={isBusy}
                name="Send Reset Email"
                className="mt-3 px-5 btn-green"
              />
            </div>
            <Link
              to={AppRouteUi.Login.Root()}
              className="text-green-200 float-end text-center mt-2"
            >
              Back to Login{" "}
            </Link>
          </div>
        ) : (
          <div>
            <p className="text-center text-red-300">Email not found</p>
            <Link
              to={AppRouteUi.Login.Root()}
              className="text-green-200 float-end text-center mt-2"
            >
              Back to Login
            </Link>
          </div>
        )}
      </div>
    </AuthLayout>
  );
}
